import type { CustomLabel } from '@/trendData/trendData.constants';

/** Reads stored label text. Visibility and HTML sanitization belong to the caller's display or editing context. */
export function getCustomLabelText(
  labels: readonly CustomLabel[],
  { location, target }: Pick<CustomLabel, 'location' | 'target'>,
): string {
  return labels.find((label) => label.location === location && label.target === target)?.text ?? '';
}
